import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogConfirmComponent} from '@shared/components';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {

	constructor(
		private dialog: MatDialog
	) { }

	confirm(message: string, width: string = '25%') {
		const dialog = this.dialog.open(DialogConfirmComponent, {
			width,
			height: 'auto',
			panelClass: ['Dialog'],
			autoFocus: false,
			data: {
				message
			}
		});

		return dialog;
	}
}
